import React from 'react'
import { FALLBACK_KEY } from '../utils'
import { Link } from 'ui/reshaped/Link'
import { View } from 'reshaped/bundle'
import { wrapper } from './Glossary.css'

const alphabet = [...Array(26).keys()].map(i => String.fromCharCode(i + 97))
const glossaryKeys = ['#', ...alphabet]

interface Props {
	page: string
	validPages: string[]
}

export const GlossaryKeys: React.FC<React.PropsWithChildren<Props>> = ({ page = FALLBACK_KEY, validPages }) => (
	<View bleed={5}>
		<View
			direction="row"
			backgroundColor="white"
			shadow="raised"
			borderRadius="small"
			padding={2}
			wrap={false}
			attributes={{
				style: {
					justifyContent: 'space-between',
					margin: '32px 0',
					overflowX: 'scroll',
					WebkitOverflowScrolling: 'touch'
				}
			}}
			className={wrapper}
		>
			{glossaryKeys.map(key => {
				const isActive = page === key
				const isDisabled = !validPages.includes(key.toUpperCase())
				return (
					<View
						key={key}
						direction="row"
						borderRadius="medium"
						height="40px"
						backgroundColor={isActive ? 'primary-faded' : 'white'}
						attributes={{
							style: {
								flex: 1,
								minWidth: '40px',
								justifyContent: 'center',
								alignItems: 'center',
								cursor: 'pointer',
								opacity: isDisabled ? '0.5' : '1',
								pointerEvents: isDisabled ? 'none' : 'auto'
							}
						}}
					>
						<Link href={`/learn/glossary?page=${key}`} variant="plain" color={isActive ? 'primary' : 'neutral-faded'}>
							{key.toUpperCase()}
						</Link>
					</View>
				)
			})}
		</View>
	</View>
)
